// T22.120 (Gordon D20): on a team wheel every member gets the team LEADER's
// plan features. The wheel GET carries `team_plan_tier` (the inherited leader
// tier; null when the member's own plan governs) and the builder hydrates it
// into its present state via addWheelData. Tier-gated wheel-authoring controls
// raise the account tier to it so they match the server gates.

export const getOpenWheelTeamPlanTier = (state) => {
  const builder = state?.segmentBuilder;
  const tier = builder?.history?.[builder.currentIndex]?.team_plan_tier;
  return typeof tier === "number" ? tier : null;
};

// Returns `subscription` unchanged unless the team tier is higher, else a copy
// whose `data.sub_tier` is the team tier.
export const raiseToTeamPlanTier = (subscription, teamPlanTier) => {
  const ownTier = subscription?.data?.sub_tier;
  if (typeof teamPlanTier !== "number" || typeof ownTier !== "number") {
    return subscription;
  }
  if (teamPlanTier <= ownTier) return subscription;
  return { ...subscription, data: { ...subscription.data, sub_tier: teamPlanTier } };
};
